module.exports = __webpack_public_path__ + "static/media/cert_153.be2ce694.jpg";